import { z } from 'zod';
/**
 * Contrato de `GET /health`. A API responde sem tocar no banco, para que o
 * endpoint continue servindo como liveness probe mesmo com o MySQL fora do ar.
 */
export const healthStatusSchema = z.enum(['ok', 'degraded']);
export const healthResponseSchema = z.object({
    status: healthStatusSchema,
    uptime: z.number().nonnegative(),
    timestamp: z.string(),
    version: z.string(),
});
//# sourceMappingURL=health.js.map